// extracted by mini-css-extract-plugin
export const wrapper = "Services-module--wrapper--iX0Kt";
export const content = "Services-module--content--3ajdg";
export const text = "Services-module--text--31e0f";
export const list = "Services-module--list--24VKn";
export const mobileButton = "Services-module--mobileButton--bNq6-";
export const button = "Services-module--button--m3wkQ";